import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import holeOutRuleService from "./holeOutRuleService";

export const getHoleOutRule = createAsyncThunk(
  "hole-out-price/get-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutRuleService.getHoleOutRule(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHoleOutRule = createAsyncThunk(
  "hole-out-price/update-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutRuleService.updateHoleOutRule(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  holeOutRule: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
};
export const holeOutRuleSlice = createSlice({
  name: "holeOutRule",
  initialState,
  reducers: {
    initRule: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHoleOutRule.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHoleOutRule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.holeOutRule = action.payload;
        state.isUpdateSuccess = false;
      })
      .addCase(getHoleOutRule.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateHoleOutRule.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateHoleOutRule.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload;
      })
      .addCase(updateHoleOutRule.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateSuccess = true;
      })
  },
});
export default holeOutRuleSlice.reducer;
export const { initRule } = holeOutRuleSlice.actions;